import { render, staticRenderFns } from "./ReportIssuePage.vue?vue&type=template&id=c29bbf96"
import script from "./ReportIssuePage.vue?vue&type=script&lang=js"
export * from "./ReportIssuePage.vue?vue&type=script&lang=js"
import style0 from "./ReportIssuePage.vue?vue&type=style&index=0&id=c29bbf96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports